import { render, staticRenderFns } from "./inForm.vue?vue&type=template&id=710c6f24&scoped=true&"
import script from "./inForm.vue?vue&type=script&lang=js&"
export * from "./inForm.vue?vue&type=script&lang=js&"
import style0 from "./inForm.vue?vue&type=style&index=0&id=710c6f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c6f24",
  null
  
)

export default component.exports